import api from './utilPartner';

const controller = 'DadosBancarios';
const url = process.env.VUE_APP_ROOT_API + controller;
export default Object.assign({}, api.GetCrud(controller, null), {
  LocalizarDadosBancarios: dto => {
    return api.Axios.GetParams(`${url}/LocalizarDadosBancarios`, dto);
  },
  AtualizarDadosBancarios: dto => {
    return api.Axios.Post(`${url}/AtualizarDadosBancarios`, dto);
  }
});
